import { LinkButton } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { handleBeaconClick } from "shared/utils";
import { ErrorText } from "../ErrorText";

export const SimpleErrorNotification = () => {
  const { t } = useTranslation();
  return (
    <ErrorText>
      {t("core:ERROR.ERROR_NOTIFICATION")},&nbsp;
      <LinkButton onClick={handleBeaconClick}>
        {t("core:ERROR.CONTACT_SUPPORT")}
      </LinkButton>
    </ErrorText>
  );
};
